import { useContext } from "react";
import { Typography, Box } from "@mui/material";
import { RelatedRecordsContext } from "../../components/recordsRelated/RecordsRelated";
import { calculateTotalOfOrders } from "./utils";
import { useUser } from "../../api/useAuth";
import {ROLES} from "../../utils/constants";

export const TreatmentOrdersTotal = () => {
    const relatedRecordsContext = useContext(RelatedRecordsContext);
    const {data: user} = useUser();
    const isAdmin = user?.role.id === ROLES.admin;

    if (!relatedRecordsContext?.items) return null;

    const total = calculateTotalOfOrders(relatedRecordsContext.items);
    const totalInEuros = total.toLocaleString("pt-PT", { style: "currency", currency: "EUR" });

    if (!isAdmin) return null;
    
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 ,mr: "auto" , ml: 2}}>
            <Typography variant="h6" color="text.primary">
                Total:
            </Typography>
            <Typography variant="h6" >
                {totalInEuros}
            </Typography>
        </Box>
    );
};

